const SVGRotateRight = () => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M21 12a9 9 0 1 1-3.36-7' />
      <path d='M21 4v6h-6' />
    </svg>
  )
}

export default SVGRotateRight
